<template>
  <div class="service-book-dashboard px-0 ml-md-3">
    <b-overlay :show="loading">
      <div class="row mb-4">
        <div class="col-md-10 col-sm-12">
          <h4 class="atlhr-dashboard-title mt-10">
            Personal<span><a v-bind:href="$api_url">Dashboard</a> / Leave & Attendance /
              Personal</span>
          </h4>
        </div>
        <div class="col-md-2 col-sm-12 d-flex align-items-center justify-content-end"></div>
      </div>

      <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper">
        <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab roster-approval-front-tab"
          nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
          <b-tab lazy>
            <template active v-slot:title>
              <span class="nav-text font-weight-bolder">Attendance</span>
            </template>
            <div class="tab-item-wrapper">
              <div class="leave-log leave-attendance-front-container py-3 px-4 my-3">
                <div class="attendance-log">
                  <h5 class="company-form-box-title mb-3 pb-3">
                    Attendance Calendar
                  </h5>
                  <div class="row">
                    <div class="col-md-9">
                      <v-calendar is-expanded :columns="2" :masks="masks" :attributes="attributes"
                        :first-day-of-week="first_day_of_week" ref="trzcalendar"
                        class="v-calendar allemployeeleavewrapper-calander" @update:to-page="monthDetailsNew"
                        :from-page="page">
                        <template slot="day-content" class="vc-w-full vc-relative" slot-scope="{
                              day,
                              dayEvents,
                              attributes,
                              attributesMap,
                              popover,
                            }">
                          <div v-if="
                            this_month_holidays &&
                            this_month_holidays[day.id]
                          " :class="'vc-day-content ' +
                                (this_month_holidays[day.id].status === 'holiday' ? '' : (this_month_holidays[day.id].status || ''))
                                " :style="{
                                'background-color': getDayBgColor(day.id),
                                color: getDayTextColor(day.id),
                              }" :title="this_month_holidays[day.id].title || ''">
                            <div class="flex flex-column overflow-hidden">
                              {{ day.day }}
                            </div>
                          </div>
                          <div v-else class="vc-day-content">
                            <div class="flex flex-column overflow-hidden">
                              {{ day.day }}
                            </div>
                          </div>
                        </template>
                      </v-calendar>
                    </div>
                    <div class="col-md-3">
                      <div class="legend personal-front-calender mt-1">
                        <div class="row trz_borders mx-2">
                          <div class="col-sm-12">
                            <div class="mark current"></div>
                            <div class="text">Today</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark" :style="{ 'background-color': legends.absent }"></div>
                            <div class="text">Absent</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark" :style="{ 'background-color': legends.present }"></div>
                            <div class="text">Present</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark" :style="{
                              'background-color': holiday_color_code,
                            }"></div>
                            <div class="text">Holiday</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark" :style="{
                              'background-color': weekend_color_code,
                            }"></div>
                            <div class="text">Weekend</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark late" :style="{ 'background-color': legends.late }"></div>
                            <div class="text">Late</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark left-early" :style="{ 'background-color': legends.early }"></div>
                            <div class="text">Left Early</div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mark" :style="{ 'background-color': '#6c757d' }"></div>
                            <div class="text">Unassigned</div>
                          </div>
                          <div class="col-sm-12" v-for="leavetype in leavetypes" :key="leavetype.title">
                            <div class="mark" :style="'background:' + leavetype.color_code"></div>
                            <div class="text">{{ leavetype.title }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="leave-log my-3">
                <div class="px-3 employee-investment-wrapper py-4">
                  <h5 class="company-form-box-title mb-3 pb-3">
                    Attendance Log
                  </h5>
                  <b-input-group class="date-range-picker d-flex flex-row justify-content-start align-items-end">
                    <div class="row mx-2">
                      <div class="col-12 col-md-6 col-lg-3 d-flex flex-row justify-content-start align-items-end pl-0">
                        <b-form-group id="effective_start_date-group" label="Start Date"
                          label-for="effective_start_date" class="required-field mb-0 mr-2 mb-2 w-100">
                          <b-input-group class="mb-0">
                            <b-form-input id="effective_start_date" name="effective_start_date" v-model="start"
                              v-validate="{
                                required: true,
                                date_format: 'yyyy-mm-dd',
                              }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                              :state="validateState('effective_start_date')"
                              aria-describedby="effective_start_date-feedback" data-vv-as="Start Date" />
                            <b-input-group-append class="mb-0">
                              <b-form-datepicker class="mb-0" id="day_one" button-only right locale="en-US"
                                v-model="start" />
                            </b-input-group-append>
                            <b-form-invalid-feedback id="effective_start_date-feedback">
                              {{ veeErrors.first("effective_start_date") }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 d-flex flex-row justify-content-start align-items-end pl-0">
                        <b-form-group id="effective_end_date-group" label="End Date" label-for="effective_end_date"
                          class="required-field mb-0 mr-2 w-100">
                          <b-input-group class="mb-2">
                            <b-form-input id="effective_end_date" name="effective_end_date" v-model="end" v-validate="{
                              required: true,
                              date_format: 'yyyy-mm-dd',
                            }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                              :state="validateState('effective_end_date')"
                              aria-describedby="effective_end_date-feedback" data-vv-as="End Date" />
                            <b-input-group-append class="mb-0">
                              <b-form-datepicker :min="start" class="mb-0" id="day_two" button-only right locale="en-US"
                                v-model="end" />
                            </b-input-group-append>
                            <b-form-invalid-feedback id="effective_end_date-feedback">
                              {{ veeErrors.first("effective_end_date") }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 d-flex flex-row justify-content-start align-items-end pl-0">
                        <b-button class="mr-2 mb-2 w-100" @click="loadData">
                          Preview
                        </b-button>
                      </div>
                      <div class="col-12 col-md-6 col-lg-3 d-flex flex-row justify-content-start align-items-end pl-0">
                        <b-dropdown variant="primary" class="mb-2 mr-2 w-100" right size="sm">
                          <template #button-content>Download Job Card</template>
                          <b-dropdown-item @click="downloadJobCard(2)">Download as PDF</b-dropdown-item>
                          <b-dropdown-item @click="downloadJobCard(1)">Download as Excel</b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </b-input-group>
                </div>
                <div class="row mb-2" v-if="summaryStats.length > 0">
                  <div class="col employee-investment-wrapper px-3 py-4" v-for="stat in summaryStats" :key="stat.label">
                    <div class="stat-box company-form-container rounded p-3">
                      <h2 class="value">{{ stat.value }}</h2>
                      <p class="label">{{ stat.label }}</p>
                    </div>
                  </div>
                </div>
                <div class="mb-2" v-if="shift_distribution.length > 0 && roster == 1">
                  <div class="employee-investment-wrapper px-3 py-4">
                    <h5 class="company-form-box-title mb-3">
                      Shift Distribution
                    </h5>
                    <span v-for="d in shift_distribution" :key="d.name"
                      class="shift-tag px-2 py-1 rounded bold text-nowrap d-inline-block mb-2 mr-2"
                      :style="{ background: d.color + '22', color: d.color }">
                      {{ d.name }} ({{ d.count }} days)
                    </span>
                  </div>
                </div>
                <div class="">
                  <div class="employee-investment-wrapper px-3 py-4">
                    <h5 class="company-form-box-title mb-3">
                      Schedule Details
                    </h5>

                    <div class="table-responsive employee-table-wrapper">
                      <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
                        <thead class="table-head">
                          <tr>
                            <th>Date</th>
                            <th>Day</th>
                            <th v-if="roster == 1">Shift Name</th>
                            <th v-if="roster == 1">Shift Time</th>
                            <th>Clock In</th>
                            <th>Clock Out</th>
                            <th>Work Time</th>
                            <th>Status</th>
                            <td class="text-right" v-if="regularization">
                              Action
                            </td>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="row in paginatedData" :key="row.id || row.day + '-' + row.shift_id"
                            class="hover-bg table-row mx-2">
                            <td>
                              {{ moment(row.day).format("D MMM, YYYY") }}
                            </td>
                            <td>{{ moment(row.day).format("dddd") }}</td>
                            <td class="text-nowrap" v-if="roster == 1">
                              <span class="shift-tag small px-2 py-1 rounded bold text-nowrap d-block text-center"
                                :style="{
                                  background: row.shift.color + '22',
                                  color: row.shift.color,
                                }">
                                {{ row.shift.name }}
                              </span>
                            </td>
                            <td v-if="roster == 1" :class="{
                              'text-center': row.shift.shift_time == '-',
                            }">
                              {{ row.shift.shift_time }}
                            </td>
                            <td :class="{ 'text-center': row.check_in == '-' }">
                              {{ row.check_in }}
                            </td>
                            <td :class="{ 'text-center': row.check_out == '-' }">
                              {{ row.check_out }}
                            </td>
                            <td :class="{ 'text-center': row.work_time == '-' }">
                              {{ row.work_time }}
                            </td>
                            <td>
                              <span class="shift-tag small px-2 py-1 rounded bold d-block text-center" v-if="row.shift.shift_time != '-'" :style="{
                                background: row.label_color + '22',
                                color: row.label_color,
                              }">{{ row.label }}</span> 
                              <p v-else class="text-center mb-0">-</p>
                            </td>
                            <td class="position-relative text-right" v-if="regularization">
                              <template>
                                <a :id="'actionDropdown-' + (row.id || row.day)"
                                  v-if="(row.activity_log || row.requested || (!row.requested && row.can_request)) && row.shift.shift_time != '-'"
                                  class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button"
                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <b-icon icon="three-dots-vertical"></b-icon>
                                </a>

                                <div class="dropdown-menu action-dropdown-menu w-200 p-0" :aria-labelledby="'actionDropdown-' + (row.id || row.day)
                                  ">
                                  <b-button-group class="mr-0">
                                    <b-button variant="outline-secondary" v-if="row.activity_log"
                                      class="mr-3 rounded edit-btn" title="Show Activity Log" @click="
                                        showActivityLog(row)
                                        ">
                                      Show Activity Log
                                    </b-button>
                                    <b-button v-if="row.requested" variant="outline-secondary"
                                      class="mr-3 rounded edit-btn" title="Edit Requested Attendance" @click="
                                        reqAttendanceModal(row, row.requested)
                                        ">
                                      Edit Requested Attendance
                                    </b-button>

                                    <b-button v-if="row.requested" variant="outline-secondary"
                                      class="mr-3 rounded edit-btn" title="Delete Requested Attendance" @click="
                                        deleteRequestedAttendance(
                                          row.requested.id
                                        )
                                        ">
                                      Delete Requested Attendance
                                    </b-button>

                                    <b-button v-if="!row.requested && row.can_request" variant="outline-secondary"
                                      class="mr-3 rounded edit-btn" title="Request Attendance"
                                      @click="reqAttendanceModal(row)">
                                      Request Attendance
                                    </b-button>
                                  </b-button-group>
                                </div>
                              </template>
                            </td>
                          </tr>

                          <tr v-if="!rows.length" class="hover-bg table-row mx-2">
                            <td colspan="8" class="text-muted text-center py-3">
                              No schedule found for the selected date range.
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="">
                        <div class="clearfix mt-2 mb-2">
                          <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                              <b-form-select v-model="temp_length" :options="length_options"
                                @change="setFirstPage()"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">
                              per page. Total {{ rows.length }} records found.
                            </li>
                          </ul>
                          <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab lazy>
            <template active v-slot:title>
              <span class="nav-text font-weight-bolder">Leave</span>
            </template>
            <div class="tab-item-wrapper">
              <roster-ess-leave-log :flg="1" :key="componentKey"></roster-ess-leave-log>
            </div>
          </b-tab>
          <b-tab lazy>
            <template active v-slot:title>
                <span class="nav-text font-weight-bolder">Swap</span>
            </template>
            <div class="tab-item-wrapper">
                <roster-ess-swaps :flg="1" :key="componentKey"></roster-ess-swaps>
            </div>
        </b-tab>

        </b-tabs>
      </div>

      <b-modal id="bv-modal-request-attendance"
        :title="fdata.id != 0 ? 'Edit Requested Attendance' : 'Request Attendance'" hide-footer centered size="md">
        <b-overlay :show="loading">
          <div v-if="assignment">
            <div class="mb-3 border-0 bg-light company-form-container rounded p-3">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h6 class="mb-1 font-weight-bold">
                    {{ assignment.shift ? assignment.shift.name : "" }}
                  </h6>

                  <small class="text-muted">
                    {{ assignment.day }}
                  </small>
                </div>

                <div class="px-2 py-1 text-white d-inline radius-8 d-inline" :style="{
                  backgroundColor: assignment.label_color || '#6c757d',
                }">
                  {{ assignment.label || "N/A" }}
                </div>
              </div>

              <b-row>
                <b-col cols="12" md="6" class="mb-2">
                  <div class="bg-white border rounded p-2 h-100">
                    <small class="text-muted d-block">Work Time</small>
                    <strong class="small">
                      {{ assignment.work_time || "N/A" }}
                    </strong>
                  </div>
                </b-col>

                <b-col cols="12" md="6" class="mb-2">
                  <div class="bg-white border rounded p-2 h-100">
                    <small class="text-muted d-block">Shift Time</small>
                    <strong class="small">
                      {{
                        assignment.shift ? assignment.shift.shift_time : "N/A"
                      }}
                    </strong>
                  </div>
                </b-col>

                <b-col cols="12" md="6" class="mb-2">
                  <div class="bg-white border rounded p-2 h-100">
                    <small class="text-muted d-block">Clock In</small>
                    <strong class="small">
                      {{ assignment.check_in || "N/A" }}
                    </strong>
                  </div>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                  <div class="bg-white border rounded p-2 h-100">
                    <small class="text-muted d-block">Clock Out</small>
                    <strong class="small">
                      {{ assignment.check_out || "N/A" }}
                    </strong>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Attendance Time -->
            <div class="row">
              <div class="col-6">
                <b-form-group label="Check In Time" label-for="check_in_time" class="mb-2">
                  <b-form-timepicker id="check_in_time" name="check_in_time" v-model="fdata.check_in_time"
                    data-vv-as="Requested Check In Time" :state="validateState('check_in_time')" minutes-step="1"
                    reset-button :show-seconds="false" locale="en-US" :hour12="true" :label-close-button="'Save'"
                    aria-describedby="check_in_time-feedback" />
                  <b-form-invalid-feedback id="check_in_time-feedback" v-if="veeErrors.has('check_in_time')">{{
                    veeErrors.first("check_in_time")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="Check Out Time" label-for="check_out_time" class="mb-2">
                  <b-form-timepicker id="check_out_time" name="check_out_time" v-model="fdata.check_out_time"
                    data-vv-as="Requested Check Out Time" :state="validateState('check_out_time')" minutes-step="1"
                    reset-button :show-seconds="false" locale="en-US" :hour12="true" :label-close-button="'Save'"
                    aria-describedby="check_out_time-feedback" />
                  <b-form-invalid-feedback id="check_out_time-feedback" v-if="veeErrors.has('check_out_time')">{{
                    veeErrors.first("check_out_time")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>

            <small class="text-muted d-block mb-3">
              Select the attendance time that should be recorded.
            </small>
            <b-form-group id="comment-group" label="Reason" label-for="comment">
              <b-form-textarea id="comment" name="comment" rows="4" max-rows="6" no-resize v-model="fdata.comment"
                :state="validateState('comment')" aria-describedby="comment-feedback"
                data-vv-as="Reason"></b-form-textarea>
              <b-form-invalid-feedback id="comment-feedback">{{
                veeErrors.first("comment")
                }}</b-form-invalid-feedback>
            </b-form-group>

            <!-- Actions -->
            <div class="d-flex justify-content-center pt-3">
              <b-button variant="primary" class="mr-2" @click="$bvModal.hide('bv-modal-request-attendance')">
                Cancel
              </b-button>

              <b-button variant="primary" @click="submitAttendanceRequest">
                {{ fdata.id != 0 ? "Update" : "Submit" }}
                Request
              </b-button>
            </div>
          </div>
        </b-overlay>
      </b-modal>
      <b-modal id="activity_logModal" size="xl" scrollable  hide-footer title="Attendance Info">
          <div class="row no-margin">
              <div class="col-md-6">
                  <div class="card punch-status">
                      <div class="card-body">
                          <h5 class="card-title">Timesheet <small class="text-muted">{{period_date}}</small></h5>
                        <p class="" v-if="shift">
                          {{ roster == 1 ? 'Shift' : 'Office Time' }}:
                          <small class="text-muted p-2" style="border-radius: 6px;" :style="{background: shift.color + '40', color:shift.color}">
                            {{ shift.name }}
                            ({{ shift_time }})
                          </small>
                        </p>
                        <div class="punch-det">
                              <h6>Punch In at</h6>
                              <p>{{check_in}}</p>
                          </div>
                          <div class="punch-info">
                              <div class="punch-hours">
                                  <span>{{work_time}}</span>
                              </div>
                          </div>
                          <div class="punch-det">
                              <h6>Punch Out at</h6>
                              <p>{{check_out}}</p>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-6">
                  <div class="card recent-activity">
                      <div class="card-body">
                          <h5 class="card-title">Activity</h5>
                          <ul class="res-activity-list" v-if="activity_log">
                              <li v-for="(activity, index) in activity_log">
                                  <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                  <p class="mb-0" v-else>Punch Out at</p>
                                  <p class="res-activity-time">
                                      <i class="far fa-clock"></i>
                                      {{ activity }}
                                  </p>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    let sortOrders = {};
    let columns = [
      { label: "Name", name: "name" },
      { label: "Date Uploaded", name: "created_at" },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return {
      componentKey: 0,
      leave_limit: "",
      leave_attendance_report: [],
      fdata: {
        id: 0,
        check_in_time: null,
        check_out_time: null,
        comment: "",
        assignment_id: null,
      },
      roster: 0,
      loading: false,
      regularization: 0,
      assignment: null,
      componentKey: 0,
      employee_id: 0,
      selectedEmployee: null,
      start: this.toYMD(first),
      end: this.toYMD(last),
      rows: [],
      loading: false,
      error: null,
      shift_distribution: [],
      company_options: [],
      custom_list: [],
      summaryStats: [],
      leave_available: [],

      columns: columns,
      sortKey: "name",
      sortOrders: sortOrders,
      length: 30,
      activity_log:[],
      check_in:'',
      check_out:'',
      work_time: 0,
      shift: null,
      period_date: '',
      shift_time: '',
      // pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

      temp_length: 30,
      showoverlay_list: false,
      pagination: { currentPage: 1, pages: 1 },

      length_options: [
        { value: 30, text: "30" },
        { value: 60, text: "60" },
        { value: 180, text: "180" },
        { value: 365, text: "365" },
      ],

      // Calendar dummy data
      masks: {
        title: "MMMM YYYY",
        weekdays: "W",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
      attributes: [
        {
          key: "today",
          dot: "pink",
          dates: new Date(),
        },
      ],
      first_day_of_week: 1,
      weekly_holidays: [], // Saturday, Sunday
      this_month_holidays: {},
      weekend_color_code: "#e9ecef",
      holiday_color_code: "#ffccd5",
      approved_leaves_today: 3,
      pending_leaves_fiscal_year: 8,
      page: { month: 7, year: 2026 },
      legends: {},
      leavetypes: [],
    };
  },
  methods: {
    moment,
    showActivityLog(row){
      this.check_in = row.check_in;
      this.check_out = row.check_out;
      this.work_time = row.work_time;
      this.period_date = row.day;
      this.shift = row.shift;
      this.shift_time = row.shift.shift_time;
      if(row.activity_log) {
        this.activity_log = row.activity_log.sort((a, b) => {
          return new Date(a.time) - new Date(b.time);
        });
        this.$bvModal.show('activity_logModal');
      } else {
        this.$bvToast.toast('No activity log is present.', {
          variant: 'danger',
          title: 'Failed',
          solid: true,
        });
      }
    },
    monthDetails(page) {
      console.log("v-calendar update:to-page triggered:", page);
    },
    monthDetailsNew(page) {
      console.log("monthDetailsNew page update:", page);
    },
    getLeaveTypeByLeavePolicy: function (f = 0) {
      if (!this.checkNet()) return false;

      axios
        .get(this.$api_url + "/front/leave-attendance/leave/type/policy?f=" + f)
        .then((response) => {
          let leavetypes = response.data;
          this.leavetypes = leavetypes.map((el) => {
            return {
              title: el.leave_type_title,
              color_code: el.color_code,
            };
          });
        });
    },

    getLeaveAttendanceReport: function () {
      if (!this.checkNet()) return false;

      axios
        .get(
          this.$api_url +
          "/front/leave-attendance/leave/attendances/report/fiscalyear"
        )
        .then(
          function (response) {
            this.leave_attendance_report = response.data;
            this.legends = this.leave_attendance_report.legends;
            this.this_month_holidays =
              this.leave_attendance_report.this_month_holidays;
            if (response.data.holiday_color_code) {
              this.holiday_color_code = response.data.holiday_color_code;
            }
            if (response.data.weekend_color_code) {
              this.weekend_color_code = response.data.weekend_color_code;
            }
          }.bind(this)
        );
    },
    getDayBgColor(dayId) {
      if (!this.this_month_holidays || !this.this_month_holidays[dayId]) {
        return "";
      }
      const dayData = this.this_month_holidays[dayId];
      if (dayData.status === "weekend" || dayData.status === "off_day") {
        return this.weekend_color_code || "#e9ecef";
      }
      if (dayData.status === "holiday") {
        return this.holiday_color_code || "#ffccd5";
      }
      return dayData.color || "";
    },
    getDayTextColor(dayId) {
      if (!this.this_month_holidays || !this.this_month_holidays[dayId]) {
        return "";
      }
      const dayData = this.this_month_holidays[dayId];
      if (dayData.status === "weekend" || dayData.status === "off_day") {
        return "#495057";
      }
      if (dayData.status === "holiday") {
        return "#212529";
      }
      return dayData.color ? "#ffffff" : "";
    },
    getCompanyLeaveSettings: function () {
      if (!this.checkNet()) return false;
      axios
        .get(this.$api_url + "/front/leave-attendance/company/leave/settings")
        .then(
          function (response) {
            if (response.data.length != 0) {
              this.roster = response.data.roster;
              this.regularization = response.data.regularization;
            }
          }.bind(this)
        );
    },
    reqAttendanceModal(row, requested = null) {
      this.fdata.assignment_id = row.id;
      this.assignment = row;
      if (requested != null) {
        this.fdata.id = requested.id;
        this.fdata.check_in_time = requested.check_in_time;
        this.fdata.check_out_time = requested.check_out_time;
        this.fdata.comment = requested.comment;
      } else {
        this.fdata.id = 0;
        this.fdata.check_in_time = null;
        this.fdata.check_out_time = null;
        this.fdata.comment = "";
      }
      this.$bvModal.show("bv-modal-request-attendance");
    },
    
    submitAttendanceRequest() {
        if(this.fdata.check_in_time == null && this.fdata.check_out_time == null) {
        this.$bvToast.toast('No time selected', {
            title: 'Error',
            solid: true,
            variant: 'danger'
        });
        return;
        }
        this.loading = true;
        let formData = new FormData();
        for (let [k, v] of Object.entries(this.fdata)) {
        formData.append(k, v);
        }
        axios
        .post(
            this.$api_url + "/front/leave-attendance/attendance/request",
            formData
        )
        .then((response) => {
            this.$bvToast.toast(response.data.message, {
            title: "Success",
            variant: "success",
            solid: true,
            });
            this.$bvModal.hide("bv-modal-request-attendance");
            this.loadData();
            this.loading = false;
        }).catch(e=> {
            this.loading = false;
            this.serverError(e);
        });
    },
    closeModal() {
      this.loadData();
      this.$bvModal.hide("bv-modal-manual-shift-assignment");
    },
    toYMD(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    deleteRequestedAttendance(id) {
      let formData = new FormData();
      formData.append("id", id);
      axios
        .post(
          this.$api_url + "/front/leave-attendance/attendance/request/delete",
          formData
        )
        .then((response) => {
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.loadData();
        });
    },

    // 31 march 2026
    downloadJobCard(format) {
      if (!this.checkNet()) return;
      this.$bvToast.toast("Preparing download, this may take a while.", {
        title: "Hold Tight",
        variant: "info",
        solid: true,
      });
      let formData = new FormData();
      formData.append("from_date", this.start);
      formData.append("to_date", this.end);
      formData.append("export", format);
      axios
        .post(this.$api_url + "/front/leave-attendance/job-card", formData, {
          responseType: "blob",
        })
        .then((response) => {
          this.global_download_file_content(response);
        })
        .catch((e) => {
          this.serverError(e);
        });
    },
    // 31 march 2026
    loadData() {
      if (!this.start || !this.end) return;
      this.loading = true;
      this.error = null;

      axios
        .get(this.$api_url + "/front/leave-attendance/assignments/employee", {
          params: {
            start: this.start,
            end: this.end,
          },
        })
        .then((response) => {
          const data = response.data;
          this.rows = data.report || [];
          const counts = {};
          for (const row of this.rows) {
            const sid = row.shift_id;
            if (!sid) continue;
            const sh = row.shift || {};
            if (!counts[sid]) {
              counts[sid] = {};
              counts[sid].id = sid;
              counts[sid].name = sh.name || "Shift " + sid;
              counts[sid].color = sh.color || null;
              counts[sid].count = 0;
            }
            counts[sid].count = counts[sid].count + 1;
          }
          this.shift_distribution = Object.values(counts);
          this.loading = false;
        })
        .catch((e) => {
          this.serverError(e);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
    this.getCompanyLeaveSettings();
    this.getLeaveTypeByLeavePolicy();
    this.getLeaveAttendanceReport();
  },
  computed: {
    filteredData() {
      let filtered_list = this.rows;
      if (this.search) {
        filtered_list = filtered_list.filter((row) => {
          return Object.keys(row).some((key) => {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            );
          });
        });

        if (filtered_list.length == 0) this.blankmsg = "No doucments found";
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;

      return filtered_list;
    },
    paginatedData() {
      return this.paginate(
        this.filteredData,
        this.length,
        this.pagination.currentPage
      );
    },
  },
};
</script>
